module.exports = __webpack_public_path__ + "static/media/rsz_spin.56d06a44.png";